import History from "@irati/utils/history"
import getCategoryFromTag from "@irati/deals/helpers/categories/getCategoryFromTag"

export const navigateToCategoryWithTag = (navigateTag, context) => {
  getCategoryFromTag(navigateTag.uuid).then((category) => {
    if (category) {
      History.push(
        {
          pathname: `/categories/${category.url}`,
          state: {
            header: category.name,
            categoryUuid: category.uuid
          }
        },
        context
      )
    } else {
      History.push(
        {
          pathname: "/categories"
        },
        context
      )
    }
  })
}
